import {get, post, del, patch} from "../api"
import * as url from "../url"

const apiGetGroupsList = data => {
  return get(url.API_GROUPS, data.history)
}

const apiPostGroupsNew = data => {
  return post(url.API_GROUPS, data.history, data.values)
}

const apiPatchGroupsEdit = data => {
  return patch(url.API_GROUPS + data.id + "/", data.history, data.values)
}

const apiDeleteGroupsDelete = data => {
  return del(url.API_GROUPS + data.id + "/", data.history)
}

const apiGetUsersList = data => {
  return get(url.API_USERS + "simple/", data.history)
}

const apiGetGroupSelectList = data => {
  return get(url.API_GROUPS + "select-list/", data.history)
}

export {
  apiGetGroupsList,
  apiPostGroupsNew,
  apiPatchGroupsEdit,
  apiDeleteGroupsDelete,
  apiGetUsersList,
  apiGetGroupSelectList,
}
